var React = require('react');

function Gadgets (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#00deb2;}")),React.createElement("title",{"key":1},"Tick "),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("polygon",{"className":"cls-1","points":"22.95 0 7.28 16.29 1.01 9.78 1.01 9.78 1.01 9.78 0 12.98 7.28 20.51 23.96 3.16 22.95 0"})))]);
}

Gadgets.defaultProps = {"viewBox":"0 0 23.96 20.51"};

module.exports = Gadgets;

Gadgets.default = Gadgets;
